import {Grid, Container} from "@mui/material";
import ColorBox from "./facturee-colors";
import {useTheme} from "@mui/material/styles";
import React from "react";
import ShowCode from "../../helpers/ShowCode.js";

const useColors = () => {
  const theme = useTheme();
  return [
    {name: "Primary", value: theme.palette.primary.main},
    {name: "Primary Shy", value: theme.palette.primary.shy},
    {name: "Primary Light", value: theme.palette.primary.light},
    {name: "Secondary", value: theme.palette.secondary.main},
    {name: "Secondary Shy", value: theme.palette.secondary.shy},
    {name: "Secondary Light", value: theme.palette.secondary.light},
    {name: "Tertiary", value: theme.palette.tertiary.main},
    {name: "Tertiary Shy", value: theme.palette.tertiary.shy},
    {name: "Tertiary Light", value: theme.palette.tertiary.light},
    {name: "Quartery", value: theme.palette.quartery.main},
    {name: "Quartery Shy", value: theme.palette.quartery.shy},
    {name: "Quartery Light", value: theme.palette.quartery.light},
    {name: "Error", value: theme.palette.error.main},
    {name: "Warning", value: theme.palette.warning.main},
    {name: "Info", value: theme.palette.info.main},
    {name: "Success", value: theme.palette.success.main},
    {name: "Sales", value: theme.palette.sales.main},
    {name: "Purchase", value: theme.palette.purchase.main},
    {name: "Accounting", value: theme.palette.accounting.main},
    {name: "QM", value: theme.palette.qm.main},
    {name: "Packing", value: theme.palette.packing.main},
    {name: "Logistics", value: theme.palette.logistics.main},
    {name: "From Request Tool", value: theme.palette.fromRequestTool.main},
    {name: "From Email", value: theme.palette.fromEmail.main},
    {name: "From Drawing", value: theme.palette.fromDrawing.main},

  ];
};

const FactureeColorGrid = () => {
  const colors = useColors();
  const theme = useTheme();

  return (
    <>
      <Container>
        <Grid container spacing={2}>
          {colors.map((c) => (
            <Grid item xs={6} sm={6} md={4} key={c.name}>
              <ColorBox 
                name={c.name} 
                color={c.value}
                textColor={c.name.includes("Shy") || c.name.includes("Light") ? theme.palette.primary.main : "#fff"}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </>
  );
};

export default FactureeColorGrid;
